import { LAT_MIN, LAT_MAX, LON_MIN, LON_MAX } from './constants';

export const isLatValid = (value) => {
  if (value === '' || value === null || value === undefined) {return false;}
  const n = Number(value);
  return Number.isFinite(n) && n >= LAT_MIN && n <= LAT_MAX;
};

export const isLonValid = (value) => {
  if (value === '' || value === null || value === undefined) {return false;}
  const n = Number(value);
  return Number.isFinite(n) && n >= LON_MIN && n <= LON_MAX;
};

export const isFiniteNumber = (value) => {
  if (value === '' || value === null || value === undefined) {return false;}
  return Number.isFinite(Number(value));
};

// Allow incremental typing of a signed decimal: '', '-', '12', '12.', '-12.34'.
export const PARTIAL_NUMERIC = /^-?\d*\.?\d*$/;
export const filterNumeric = (next, prev) => (PARTIAL_NUMERIC.test(next) ? next : prev);

export const disabledCursor = (isDisabled) => (isDisabled ? {cursor: 'not-allowed'} : null);

// Prefer the human-readable label produced by Carmen; otherwise stitch from parts.
// For forward lookups, also show the resolved lat/lon so the user can verify.
export const formatGeoResult = (geo) => {
  const place = geo.location || [geo.city, geo.subdivision, geo.country].filter(Boolean).join(', ');
  if (geo.location && geo.latlong && geo.latlong.lat != null && geo.latlong.lon != null) {
    return `${place} (${geo.latlong.lat}, ${geo.latlong.lon})`;
  }
  return place;
};
